import { BaseTableRow, getHeaderName, GridRowParams, TableProps } from "@/types";
import { SyntheticEvent } from "react";
import { Table } from "./Table";

interface SingleColumnTableRow extends BaseTableRow {
  name?: string;
}

interface SingleColumnTableProps<
  T extends SingleColumnTableRow = SingleColumnTableRow
> extends TableProps<T> {}

export class SingleColumnTable<T extends SingleColumnTableRow = SingleColumnTableRow> extends Table<
  T,
  SingleColumnTableProps<T>
> {
  static columns = {
    attributes: {
      field: "attributes",
      label: "tableColumns.competencies"
    },
    regulations: {
      field: "regulations",
      label: "tableColumns.regulations"
    },
    jobDefinitions: {
      field: "jobDefinitions",
      label: "tableColumns.jobDefinitions"
    },
    task: {
      field: "task",
      label: "tableColumns.tasks"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    noRowsMessage: "No rows, yet"
  };

  constructor(props: SingleColumnTableProps<T>) {
    super(props);

    this.state = {
      ...this.state
    };
  }

  onRowClick(params: GridRowParams<T>, e: SyntheticEvent) {
    const { onAttributeSelect } = this.props;
    if (onAttributeSelect) onAttributeSelect(e, params.row);
  }

  initColumns() {
    const { columns, sortable } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c) => {
      if (this.hasColumn(c)) {
        if (c.type === SingleColumnTable.columns.attributes)
          this.columns.push({
            field: "attributes",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.name,
            renderCell: (params) => <div>{params.row.name}</div>
          });
        if (c.type === SingleColumnTable.columns.regulations)
          this.columns.push({
            field: "regulations",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.name,
            renderCell: (params) => <div>{params.row.name}</div>
          });
        if (c.type === SingleColumnTable.columns.jobDefinitions)
          this.columns.push({
            field: "jobDefinitions",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.name,
            renderCell: (params) => <div>{params.row.name}</div>
          });

        if (c.type === SingleColumnTable.columns.task)
          this.columns.push({
            field: "task",
            headerName: getHeaderName(c, this.props.translate),
            sortable: sortable,
            filterable: false,
            disableReorder: true,
            flex: 1,
            valueGetter: (_value, row) => row.name,
            renderCell: (params) => <div>{params.row.name}</div>
          });
      }
    });
  }
}
